// src/pages/HomePage.js
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './HomePage.css';
import axios from 'axios';

const HomePage = () => {
  const { examCode } = useParams();
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState('');
  const [codeInput, setCodeInput] = useState('');
  const navigate = useNavigate();

  const createExam = async () => {
    setIsCreating(true);
    setError('');

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/exam/${examCode}/start`);
      navigate(`/exam/${examCode}`);
    } catch (err) {
      setError('Esta prova já foi finalizada.');
      console.error('Erro:', err);
      setIsCreating(false);
    }
  };

  const handleCodeSubmit = (e) => {
    e.preventDefault();
    const trimmedCode = codeInput.trim();
    if (!trimmedCode) {
      setError('Informe o código da sua avaliação.');
      return;
    }
    navigate(`/${trimmedCode.toUpperCase()}`);
  };

  // Sem código na URL: pede para o aluno informar o código recebido por e-mail/WhatsApp
  if (!examCode) {
    return (
      <div className="home-container">
        <span className="home-eyebrow">Vestibular 2027/1</span>
        <h2>
          Acesse sua <strong>avaliação</strong>
        </h2>
        <p className="home-intro">
          Digite abaixo o código da prova que você recebeu por e-mail para começar.
        </p>

        <form className="code-form" onSubmit={handleCodeSubmit}>
          <input
            type="text"
            className="code-input"
            placeholder="Ex.: A1B2C3D4"
            value={codeInput}
            onChange={(e) => setCodeInput(e.target.value)}
            autoFocus
            maxLength={20}
          />
          <button type="submit" className="create-exam-btn">
            Acessar Avaliação
          </button>
        </form>
        {error && <p className="error-message">{error}</p>}
      </div>
    );
  }

  return (
    <div className="home-container">
      <span className="home-eyebrow">Vestibular 2027/1</span>
      <h2>
        Seja bem-vindo à <strong>FAPAM</strong>
      </h2>
      <p className="home-intro">
        Você está prestes a dar um passo importante na construção do seu
        futuro. Aqui, acreditamos que o conhecimento transforma — e você
        acaba de escolher uma instituição que vai caminhar com você nessa
        jornada.
      </p>
      <p className="home-highlight">Venha transformar seu futuro!</p>

      <ul className="home-rules">
        <li>
          <span className="rule-icon">📝</span>
          20 questões de múltipla escolha (Português e Matemática)
        </li>
        <li>
          <span className="rule-icon">⏱️</span>
          2 horas para concluir toda a prova
        </li>
        <li>
          <span className="rule-icon">✔️</span>
          Responda com atenção — não é possível voltar a uma questão já enviada
        </li>
      </ul>

      <button
        className="create-exam-btn"
        onClick={createExam}
        disabled={isCreating}
      >
        {isCreating ? 'Iniciando...' : 'Iniciar Avaliação'}
      </button>
      {error && <p className="error-message">{error}</p>}
      <p className="home-goodluck">Boa sorte!</p>
    </div>
  );
};

export default HomePage;